import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeRequest } from "../../api/api";

export const getPoolingNotifications = createAsyncThunk(
  'poolingNotification/getPoolingNotifications',
  async (params) => {
    const request = await makeRequest("get", "", params)
    const response = await request.data.data
    return response
  }
)


const poolingNotificationSlice = createSlice({
  name: "poolingNotification",
  initialState: {
    pageLoding: 'idle',
    notificationListPooling: [],
    selectedFilterType: 'all',
    notificationTabDetails: {},
    notificationPagination: {},
  },
  reducers: {
    setSelectedFilterType: (state, action) => {
      state.selectedFilterType = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPoolingNotifications.pending, (state) => {
        state.pageLoding = 'loading';
        state.notificationListPooling = [];
        state.notificationTabDetails = {};
        state.notificationPagination = {};
      })
      .addCase(getPoolingNotifications.fulfilled, (state, action) => {
        state.pageLoding = 'succeeded';
        state.notificationListPooling = action.payload.data;
        state.notificationTabDetails = action.payload.tabs;
        state.notificationPagination = action.payload.pagination;
      })
      .addCase(getPoolingNotifications.rejected, (state) => {
        state.pageLoding = 'failed';
        state.notificationListPooling = [];
        state.notificationTabDetails = { all: 0, new: 0, accepted: 0, rejected: 0, declined: 0 };
        state.notificationPagination = { current_page: 1, totalPages: 1, per_page: 10, total_notifications: 0 };
      })

  },
})

// Reducer variables
export const { setSelectedFilterType } = poolingNotificationSlice.actions;

export default poolingNotificationSlice.reducer;